import React, { useEffect, useState } from 'react';

function Home() {
  const [activeService, setActiveService] = useState(0);
  const services = ['NZBFinder', 'SabNZBD', 'NZBGet'];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveService((prev) => (prev + 1) % services.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [services.length]);

  return (
    <>
      {/* Hero Section */}
      <div className="hero">
        <div className="app-icon">
          <img
            src="/images/nzbee-logo-256.png"
            alt="NZBEE App Icon"
            className="app-icon-img"
          />
        </div>

        <h1 className="hero-title">
          Your NZB Search & Download Manager
        </h1>

        <p className="hero-subtitle">
          Search, manage, and monitor your downloads—all from your iOS device
        </p>

        <div className="service-highlight">
          <span className="service-text">
            {services[activeService]}
          </span>
          <span className="service-suffix"> support built-in</span>
        </div>

        {/* App Store Button */}
        <a href="https://apps.apple.com" className="app-store-button">
          <svg className="app-store-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
          </svg>
          Coming soon on the App Store
        </a>

        {/* Service Pills */}
        <div className="services-grid">
          <span className="service-pill nzbfinder">NZBFinder</span>
          <span className="service-pill sabnzbd">SabNZBD</span>
          <span className="service-pill nzbget">NZBGet</span>
          <span className="service-pill feature">Voice Search</span>
          <span className="service-pill feature">iCloud Sync</span>
        </div>
      </div>

      {/* Features Section */}
      <section className="features">
        <div className="feature-card">
          <h3>Powerful Search</h3>
          <p>
            Search NZBs with advanced filtering by category. Voice search powered by iOS Speech Recognition.
          </p>
        </div>

        <div className="feature-card">
          <h3>Dual Server Support</h3>
          <p>
            Manage downloads with both SabNZBD and NZBGet. Monitor queue status,
            download progress, and history—all in real-time from your device.
          </p>
        </div>

        <div className="feature-card">
          <h3>Privacy First</h3>
          <p>
            Your credentials stay on your device. No analytics, no tracking, no servers.
            Optional iCloud sync keeps settings secure across your devices.
          </p>
        </div>

        <div className="feature-card">
          <h3>Native iOS Experience</h3>
          <p>
            Built with SwiftUI for a smooth, native iOS experience. Haptic feedback,
            pull-to-refresh, and a beautiful interface designed for iPhone.
          </p>
        </div>

        <div className="feature-card">
          <h3>Search Integration</h3>
          <p>
            NZBEE connects to third-party search services via API. Configure your own API
            access and search directly from the app. Category filtering helps you find exactly
            what you're looking for.
          </p>
        </div>

        <div className="feature-card">
          <h3>Download Management</h3>
          <p>
            Connect to your self-hosted SabNZBD or NZBGet servers. Send NZBs directly from
            search results. Monitor active downloads with real-time speed and progress updates.
            Pause, resume, or delete items right from your phone.
          </p>
        </div>

        <div className="feature-card">
          <h3>Secure & Private</h3>
          <p>
            All credentials are stored securely in iOS Keychain with encryption. Enable optional
            iCloud Sync to share settings across your devices—or keep everything local.
            You're in control of your data.
          </p>
        </div>

        <div className="feature-card">
          <h3>Voice Search</h3>
          <p>
            Tap the microphone and speak your search query. iOS Speech Recognition converts
            your voice to text instantly. Perfect for hands-free searching when you're on the go.
          </p>
        </div>
      </section>

    </>
  );
}

export default Home;
